module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 23h4V9h-4v14zm8-14v14h4V9h-4z\"></path></svg>"